import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GithubRepoDestroyInput, GithubRepoDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GithubRepoDestroyInput;
type TData = GithubRepoDestroyPayload;

export const useGithubRepoDestroy = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation githubRepoDestroy($input: GithubRepoDestroyInput!) {
      githubRepoDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
